import script from "./ColivingSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ColivingSearchBar.vue?vue&type=script&setup=true&lang=js"

import "./ColivingSearchBar.vue?vue&type=style&index=0&id=54756fa7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54756fa7"]])

export default __exports__